import React from 'react'

import { Password } from 'components/authentication/form-fields/Password'
import { LowerLink } from 'components/authentication/LowerLink'
import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import InputTextField from 'components/common/InputTextField'
import { isPrivateEdition } from 'utils/app-config'

export const SignInForm: React.FC<{
  email: string
  password: string
  handleEmailChange(email: string): void
  handlePasswordChange(pw: string): void
  submitting: boolean
  signInError?: string
  handlePasswordLogin(): void
  handleGoogleLogin(): void
  handleSamlLogin(): void
}> = ({
  email = '',
  password = '',
  handleEmailChange,
  handlePasswordChange,
  handlePasswordLogin,
  handleGoogleLogin,
  handleSamlLogin,
  submitting,
  signInError
}) => {
  const signinMethods = isPrivateEdition()
    ? ['password', 'saml']
    : ['password', 'google', 'saml']

  return (
    <SignedOutFormContainer data-test-signin-form>
      <SignedOutForm
        title="Log in"
        onSubmit={(event) => {
          event.preventDefault()
          handlePasswordLogin()
        }}
      >
        <InputTextField
          data-test-signin-email
          autoComplete="email"
          data-role="login-email"
          focusOnMount={true}
          label="Email"
          name="email"
          value={email}
          onChange={(event) => handleEmailChange(event.target.value)}
        />
        <Password
          handleChange={(event) => handlePasswordChange(event.target.value)}
          handleGoogle={handleGoogleLogin}
          handleSaml={handleSamlLogin}
          isLoading={!email || submitting}
          password={password}
          signInError={signInError}
          signInMethods={signinMethods}
        />
      </SignedOutForm>
      <div css={{ display: 'flex', justifyContent: 'space-between' }}>
        <LowerLink
          data-test-signed-out-below-link
          css={{ textAlign: 'left' }}
          to="/password-reset"
        >
          Forgot Password?
        </LowerLink>
      </div>
    </SignedOutFormContainer>
  )
}
